import PropTypes from "prop-types";
import React from "react";
import { Helmet } from "react-helmet-async";

const SITE_URL = "https://todostranslator.com";
const DEFAULT_IMAGE = `${SITE_URL}/assets/images/social-share.jpg`;

export const SEO = ({ title, description, path, image, jsonLd }) => {
  const fullTitle = title
    ? `${title} | Todo's Translator`
    : "Todo's Translator - Indianapolis Premier In Home Dog Training";
  const canonical = path ? `${SITE_URL}${path}` : SITE_URL;
  const ogImage = image || DEFAULT_IMAGE;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonical} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={ogImage} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      {jsonLd && (
        <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      )}
    </Helmet>
  );
};

SEO.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string.isRequired,
  path: PropTypes.string,
  image: PropTypes.string,
  jsonLd: PropTypes.object,
};
